<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-row>
      <b-col lg="4" md="6" sm="12">
        <b-card>
          <b-form @submit.prevent="uploadFile">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Nieuw bestand">
                  <b-form-file multiple v-model="newDocumentFile" accept=".pdf,.doc,.docx,.xlsx" required></b-form-file>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="Label">
                  <b-form-select :options="labels" v-model="newDocumentLabel"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-button type="submit" variant="success" class="btn btn-dark">Uploaden</b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <template #overlay>
      <div class="text-center">
        <b-spinner label="Spinning"></b-spinner>
        <p>Bestanden worden verwerkt...</p>
        <!-- We add an SR only text for screen readers -->
        <span class="sr-only">Bestanden worden verwerkt...</span>
      </div>
    </template>
  </b-overlay>

</template>

<script>
  import {uploadData, addData} from "../../../api";

  const generateLabels = (startYear) => {
      const currentYear = new Date().getFullYear();
      let years = [{value: 'general', text: 'Algemeen'}];

      // 2021 is the first year to be used as document label (according to the requirements)
      // here we are generating an array of years, starting from 2021 up to the current year
      startYear = startYear || 2021;  

      while ( startYear <= currentYear ) {
          years.push(startYear++);
      }

      return years;
  }

  export default {
    props: { options: null },

    data() {
      return {
        overlay: false,
        newDocumentFile: null,
        newDocumentLabel: null,
        labels: generateLabels(2021),
        url: null,
      };
    },

    methods: {
      uploadFile() {
        let formData = new FormData();

        if (this.newDocumentLabel !== null) {
          formData.append('label', `${this.newDocumentLabel}`);
        }

        for (let i = 0; i < this.newDocumentFile.length; i++) {
            formData.append('files[]', this.newDocumentFile[i])
        }

        this.overlay = true

        uploadData(`portal-users/${this.$route.params.id}/documents`, formData).then(({data}) => {
          this.overlay = false;
          this.newDocumentFile = null;
          this.newDocumentLabel = null;

          this.$emit('uploadedFiles', data);
        });
      },
    }
  }
</script>
